import React from "react";
import DepartementPage from "./DepartementPage";

const AMOValDOise95 = () => {
  return <DepartementPage dept="val-doise" />;
};

export default AMOValDOise95;
